
export class SdpInspector {
  public getMediaKinds(sdp: string | undefined): string[] {
    if (!sdp) return [];
    const kinds: string[] = [];
    for (const line of sdp.split(/\r?\n/)) {
      const match = line.match(/^m=(\w+)\s/);
      if (match) kinds.push(match[1]);
    }
    return kinds;
  }
}
